import React from "react";
import { useSelector } from "react-redux";

export const GenerateLogo = ({className, ...props}) => {
  const companyLogo = useSelector((state) => state.companyConfig.company_logo);
  const hubLogo = useSelector((state) => state.hubConfig.hubLogo);
  const logo = hubLogo || companyLogo;

  return logo ? (
    <div
      className={className}
      style={{
        backgroundImage: `url(${logo})`,
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      }}
    ></div>
  ) : (
    <div className={className}></div>
  );
};
